module.exports = __webpack_public_path__ + "img/tw-btn_txt.3a67c672.png";